import script from "./RightSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSideBar.vue?vue&type=script&setup=true&lang=js"

import "./RightSideBar.vue?vue&type=style&index=0&id=07061eb3&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07061eb3"]])

export default __exports__